import { Component, Prop, Mixins, Vue, Watch } from 'vue-property-decorator'
import { AxiosResponse } from 'axios'
import { TranslateResult } from 'vue-i18n'
import { VueConstructor } from 'vue'
import { BCol, BRow, BFormGroup, BButton, BDropdownItem, VBTooltip } from 'bootstrap-vue'
import { KForm, KFormInput, KFormEditor, KFormFile, KFormSelect } from '@kwixeo/form-vue'
import { CustomFieldsForm } from '@kwixeo/custom-fields-vue'
import { CustomerSelect, ContactSelect } from '@kwixeo/customers-vue'
import { TeamUserSelect, FileItem, FormModal } from '@kwixeo/interface-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import LoadTicketElements from '../../mixins/LoadTicketElements'
import TicketPriorities from '../../mixins/TicketPriorities'

@Component({
  components: {
    CustomFieldsForm,
    CustomerSelect, ContactSelect,
    KForm, KFormInput, KFormEditor, KFormFile, KFormSelect,
    TeamUserSelect, FileItem, FormModal,
    BRow, BCol, BFormGroup,
    FontAwesomeIcon
  },
  directives: {
    'b-tooltip': VBTooltip
  }
})
export default class TicketForm extends Mixins(LoadTicketElements, TicketPriorities) {
  @Prop({ default: null }) value!: Partial<KwixeoTickets.Ticket>|null
  @Prop({ default: 'button' }) element!: 'button'|'dropdown'|'modal'
  @Prop({ default: 'Créer un ticket' }) label!: TranslateResult|string
  @Prop({ default: false }) isIcon!: boolean|undefined
  @Prop({ default: null }) variant!: string|null
  @Prop({ default: null }) size!: string|null
  @Prop({ default: false }) modal!: boolean

  private modalState = false
  private temporaryFiles: KwixeoFramework.Files = []

  private ticket: KwixeoTickets.TicketForm = {
    custom_fields: [],
    tags: []
  }

  get component (): VueConstructor|null {
    switch (this.element) {
      case 'button':
        return BButton
      case 'dropdown':
        return BDropdownItem
      default:
        return null
    }
  }

  get formDatas (): KwixeoInterface.GenericObject {
    const ticket = this.ticket
    const datas: KwixeoInterface.GenericObject = {
      customer: ticket.customer ? ticket.customer.id : null,
      contact: ticket.contact ? ticket.contact.id : null,
      subject: ticket.subject,
      tags: ticket.tags?.map(tag => tag.id),
      category: ticket.category ? ticket.category.id : null,
      custom_fields: ticket.custom_fields.map(field => ({
        id: field.id,
        value: (typeof field.value === 'object' && 'id' in field.value ? field.value.id : field.value) ?? null
      })),
      priority: ticket.priority,
      files: this.temporaryFiles.map(file => file.id)
    }

    if (!this.ticket.id) {
      datas.message = ticket.message
    }
    return datas
  }

  get contactFilter (): number|undefined {
    return this.ticket.customer ? undefined : this.ticket.contact?.id
  }

  @Watch('value', { immediate: true })
  private watchValue (): void {
    this.ticket = Object.assign({
      custom_fields: [],
      tags: [],
      priority: 2
    }, this.value ? JSON.parse(JSON.stringify(this.value)) : {})
  }

  private fileUploaded (file: KwixeoFramework.File): void {
    this.temporaryFiles.push(file)
  }

  private fileDeleted (index: number): void {
    Vue.delete(this.temporaryFiles, index)
  }

  private async submitComplete (response: AxiosResponse): Promise<void> {
    await this.$router.push({
      name: 'tickets-item',
      params: {
        id: String(response.data.id)
      }
    })
  }
}
